export default class Top {
  constructor() {
    this.init();
  }

  init() {
    this.bubble_scroller();
    this.rellax();
    this.inview();
  }

  bubble_scroller() {
    const tl = new TimelineMax({ repeat: -1 });

    tl.set(".bubble_scroller__bubble", { opacity: 0, y: 100 });
    tl.set(".bubble_scroller__txt span", { opacity: 0, y: 50 });

    tl.staggerTo(
      ".bubble_scroller__txt span",
      0.6,
      { opacity: 1, y: 0 },
      0.2,
      0.5
    );
    tl.staggerTo(
      ".bubble_scroller__bubble",
      1,
      { opacity: 1, y: 0, ease: Circ.easeOut },
      0.5,
      0.5
    );
    tl.staggerTo(
      ".bubble_scroller__bubble",
      1,
      { opacity: 0, y: -100, ease: Circ.easeIn },
      0.5,
      2
    );
    tl.staggerTo(
      ".bubble_scroller__txt span",
      1,
      { opacity: 0, y: -50, rotation: "-90deg" },
      0.2,
      2.5
    );

    const $window = $(window);
    let timer = false;

    $window.on("scroll", function () {
      if (timer !== false) {
        clearTimeout(timer);
      }
      timer = setTimeout(function () {
        let scroll = $window.scrollTop();

        if (scroll > 500) {
          $(".bubble_scroller").removeClass("-visible");
        } else {
          $(".bubble_scroller").addClass("-visible");
        }
      }, 10);
    });
  }

  inview() {
    $(".c-fade").on("inview", function () {
      $(this).addClass("-anim");
    });
  }

  rellax() {
    if (!$("body").hasClass("home")) {
      return;
    }
    var rellax = new Rellax(".rellax", {
      speed: 2,
      center: false,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false,
    });
  }
}
